export { FullScreenComponent } from '@shared/layout/header/full-screen/full-screen.component';



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/full-screen/index.ts